// Tiny helper so every gallery / picker uses the same detection rules.
const VIDEO_EXT = /\.(mp4|mov|webm|m4v)(\?|#|$)/i;

export const isVideoUrl = (url) => typeof url === 'string' && VIDEO_EXT.test(url);
